import socket from '@/services/socket.js'

export default {
  /**
   * Change user password.
   *
   * @param current_password
   * @param password
   * @param user_id
   * @returns Promise
   */
  changePassword(current_password, password, user_id) {
    let action = '/password/update'
  
    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        body: {
          current_password,
          password,
          user_id
        }
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }
  
        resolve(data)
      })
    })
  }
}
